export enum ReportType {
  CISION = 1,
  CISION_IMS = 2,
  PROJECT = 3,
  CUSTOM = 4
}
